export const formError = {
  EMAIL_UNIQUE: 'Email already exists.',
  EMAIL_INVALID: 'Please enter valid email.',
  PASSWORD_LEN: 'Password must be atleast 8 characters long.',
  PASSWORD_INVALID:
    'Password must contain at least one letter, one number and one special character.',
  PASSWORD_MATCH: 'Passwords do not match.',
  FIELD_REQUIRED: 'This is a required field',
  USERNAME_EMAIL_INVALID: 'Please enter valid email or password',
  LETTERS_ONLY: 'Alphabets only.',
};

export const LIKED_PL = 'Liked';
export const WATCH_LATER_PL = 'Watch Later';
